import Vue from 'vue'

const version = 1

export class BungieOAuth {
  constructor (clientId, storage = localStorage, goToUrlCallback = (url) => { window.location = url }) {
    this.clientId = clientId
    this.storage = storage
    this.goToUrlCallback = goToUrlCallback
  }

  login () {
    this.goToUrlCallback(`https://www.bungie.net/en/OAuth/Authorize?client_id=${this.clientId}&response_type=code`)
  }

  getTokens (accessCode) {
    if (version === 2) {
      return Vue.http.post('Platform/App/GetAccessTokensFromCode/', {'code': accessCode})
        .then((response) => {
          console.log(response)
          return response.data
        })
    }

    let data = 'client_id=' + this.clientId + '&grant_type=authorization_code&code=' + accessCode
    return Vue.http.post('Platform/App/OAuth/Token/', data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
      .then((response) => {
        return response.data
      })
  }
}

import { OAUTH_CLIENT_ID } from '@/config'

export let defaultBungieOAuth = new BungieOAuth(OAUTH_CLIENT_ID)



// WEBPACK FOOTER //
// ./src/utils/auth.js